import { app } from '../../../../../app';
import { Controller } from './verify-account-owner.controller';

app.component('companyUserDirectoriesManageAccountVerify', {
    bindings: {
        account: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./verify-account-owner.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/verify/verify-account-owner.component.js